import { yStack } from 'ui/src/patterns/stack'
import type { Score, ReviewsDistribution } from '@/features/memberReviews/memberReviews.types'
import { ReviewsDistributionByScore } from './ReviewsDistributionByScore'
import { filterOption } from './ReviewsFilter.css'

type Props = {
  reviewsDistribution: ReviewsDistribution
  selectedScore: Score
  onSelectedScoreChange: (score: Score) => void
}

export function ReviewsFilter(props: Props) {
  const handleFilterOptionClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    const selectedScore = Number(event.currentTarget.value) as Score
    props.onSelectedScoreChange(selectedScore)
  }

  return (
    <div className={yStack({ gap: 'xxs' })}>
      {props.reviewsDistribution.map(([score, percentage]) => (
        <button
          key={score}
          className={filterOption}
          value={score}
          onClick={handleFilterOptionClick}
          disabled={percentage === 0}
          data-selected={score === props.selectedScore}
        >
          <ReviewsDistributionByScore score={score} percentage={percentage} />
        </button>
      ))}
    </div>
  )
}
